export default "./images/survio-Z6kt6-reference-hu.png";